import React, { useState, useEffect } from "react";
import {
  Header_panel,
  ModalDetailUser,
  ModalDetailUser1,
} from "../Useful/Useful";
import "./user.css";
import CircularProgress from '@material-ui/core/CircularProgress';

import Addimage from "../../../src/image-add.png";
import { TablePagination, Modal } from "@material-ui/core";
import { BsCheckCircle, BsXCircle } from "react-icons/bs";
import {
  ActiveTown,
  TownsGetByProvinceId,
  TownsGet,
  UserconfirmGet,
  TownsUpdate,
  ChangeChangeTownManager,
  TownsDelete,
  SearchByPhoneNumber,
  ChangeIndustrialManager,
  TownsCreate,
  TownsCreateCompelet,
} from "../../fetch";
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Switch from "@material-ui/core/Switch";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import Spinner from "react-bootstrap/Spinner";
import EditUser from "./EditUser";
import { useHistory } from "react-router-dom";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import IconButton from "@material-ui/core/IconButton";
import { FcFullTrash, FcInspection, FcFactoryBreakdown } from "react-icons/fc";
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';
export default function User_list(props) {
  const [flag, setflag] = useState(false);
  const [navid, setnavid] = useState("#navbarToggleExternalContentSettingAdd1");
  const history = useHistory();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rowslength, setrowslength] = useState(0);
  const [render, setrender] = useState(false);
  const [ShowChangeUnitone, setShowChangeUnitone] = useState(false);
  const [ShowChangeUnittwo, setShowChangeUnittwo] = useState(false);
  const [id, setId] = useState("");
  const [SearchPhoen, setSearchPhoen] = useState(null);
  const province = JSON.parse(sessionStorage.getItem("province"));
  const [PhoneResult, setPhoneResult] = useState([])
  const [Searching, setSearching] = useState(false);
  const [SearchLoading, setSearchLoading] = useState(false);
  const [SearchID, setSearchID] = useState(null);
  const [SelecredTown, setSelecredTown] = useState(null);
  console.log(province);
  useEffect(() => {
    getsettings();
  }, []);
  useEffect(() => {
    getsettings();
  }, [page, rowsPerPage]);
  const scrollBackToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  const getsettings = () => {
    setLoading(true);
    TownsGetByProvinceId(province[0].id)
      .then((response) => {
        setLoading(false);

        return response.json();
      })
      .then((responseJson) => {
        setRows(responseJson.result);

        setrowslength(responseJson.count);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  const hendleSubmit = (data) => {
    setLoading(true);
    if (
      data !== undefined &&
      data.id !== null &&
      data.id !== "" &&
      data.id !== undefined
    ) {
      TownsUpdate(data)
        .then((response) => {
          if (response.status === 200) {
            toast.success("شهرک با موفقیت ویرایش  شد");
          }
          return response.json();
        })
        .then((response) => {
          console.log(response);
          data.city = response.result.city;
          data.province = response.result.province;
          setLoading(false);
          const WheresTheDev = (obj) => obj.id === data.id;
          const idx = rows.findIndex(WheresTheDev);
          rows.splice(idx, 1, data);
          setId("");
          history.push("/main/user");
          // return response.json();
        })
        .catch((error) => {
          setLoading(false);
          // toast.error("خطای ویرایش  تنظیمات", {
          //   position: "bottom-center",
          //   autoClose: 5000,
          // });
          console.error(error);
          return null;
        });
    } else if (data.userId) {
      TownsCreate(data)
        .then((response) => {
          if (response.status === 200) {
            toast.success("شهرک با موفقیت اضافه  شد");
          }
          return response.json();
        })
        .then((response) => {
          // console.log(response);
          // data.city = response.result.city;
          // data.province = response.result.province;
          setLoading(false);
          // data.id = response.result.id;
          rows.unshift(response.result);
          setrender(!render);
          history.push("/main/user");
        })
        .catch((error) => {
          setLoading(false);
          // toast.error("خطای ویرایش  تنظیمات", {
          //   position: "bottom-center",
          //   autoClose: 5000,
          // });
          console.error(error);
          return null;
        });
    } else {
      TownsCreateCompelet(data)
        .then((response) => {
          if (response.status === 200) {
            toast.success("شهرک با موفقیت اضافه  شد");
          }
          return response.json();
        })
        .then((response) => {
          console.log(response);

          setLoading(false);
          data.id = response.result.id;
          rows.unshift(data);
          setrender(!render);

          history.push("/main/user");
        })
        .catch((error) => {
          setLoading(false);
          // toast.error("خطای ویرایش  تنظیمات", {
          //   position: "bottom-center",
          //   autoClose: 5000,
          // });
          console.error(error);
          return null;
        });
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChange = (name) => (event) => {
    const data = { id: event.target.value, isActive: event.target.checked };
    UserconfirmGet(data)
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.status === 400) {
          toast.error(responseJson.message);
        } else if (responseJson.success === true) {
          toast.success(responseJson.message);
        }

        const idx = rows.findIndex(
          (rows) => rows.id === responseJson.result.id
        );
        rows.splice(idx, 1, responseJson.result);
        setrender(!render);
        setrender(!render);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };
  const hendleDelet = (deleteId) => {
    confirmAlert({
      title: " حذف کردن ",
      message: "آیا میخواهید این کاربر راحذف کنید؟",
      buttons: [
        {
          label: "تایید",
          onClick: () => {
            setLoading(true);

            TownsDelete(deleteId)
              .then((response) => {
                setLoading(false);
                if (response.status === 200) {
                  console.log("succcess");
                  toast.success("کاربر با موفقیت حذف  شد");
                }

                return response.json();
              })
              .then((responseJson) => {
                setLoading(false);
                setRows(rows.filter((row) => row.id !== deleteId));
              })
              .catch((error) => {
                setLoading(false);
                console.log(error);
              });
          },
        },
        {
          label: "لغو",
        },
      ],
    });
  };
  const handleActive = (id) => {
    let Data = {
      TownId: id,
      IsActive: true,
    };
    ActiveTown(Data)
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (!responseJson.success) {
          toast.error(responseJson.message);
          return false;
        } else {
          toast.success(responseJson.message);
          getsettings();
          return true;
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("خطای ارتباط با سرور");
        return false;
      });
  };
  const handleDeActive = (id) => {
    let Data = {
      TownId: id,
      IsActive: false,
    };
    ActiveTown(Data)
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (!responseJson.success) {
          toast.error(responseJson.message);
          return false;
        } else {
          toast.success(responseJson.message);
          getsettings();
          return true;
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("خطای ارتباط با سرور");
        return false;
      });
  };

  console.log("sdfsdfs" + SelecredTown)

  const handleSearchByPhone = () => {
    setSearchLoading(true)
    if (SearchPhoen === null) {
      toast.error("لطفا شماره تماس مورد نظر را وارد کنید")
      setSearchLoading(false)
    } else {
      SearchByPhoneNumber(SearchPhoen)
        .then((response) => {
          return response.json();
        })
        .then((responseJson) => {
          if (!responseJson.success) {
            toast.error(responseJson.message);
            setSearching(true);
            setSearchLoading(false)
          } else {
            // toast.success(responseJson.message);
            setSearching(true);
            setSearchLoading(false)
            setPhoneResult(responseJson?.result);
            // console.log("this is data : " + JSON.stringify(responseJson?.result))
            return true;
          }
        })
        .catch((error) => {
          console.error(error);
          toast.error("خطای ارتباط با سرور");
          setSearchLoading(false)
          return false;
        });
    }
  }

  const handleSaveSearchone = () => {
    setSearchLoading(true)
    if (SearchID === null) {
      toast.error("لطفا شماره تماس مورد نظر را انتخاب کنید")
      setSearchLoading(false)
    } else {
      ChangeChangeTownManager({
        TownId: SelecredTown,
        UserId: SearchID
      })
        .then((response) => {
          return response.json();
        })
        .then((responseJson) => {
          if (!responseJson.success) {
            toast.error(responseJson.message);
            setSearching(true);
            setSearchLoading(false)
          } else {
            toast.success(responseJson.message);
            setSearching(true);
            setShowChangeUnitone(false)
            setSearchLoading(false)
            // console.log("this is data : " + JSON.stringify(responseJson?.result))
            return true;
          }
        })
        .catch((error) => {
          console.error(error);
          toast.error("خطای ارتباط با سرور");
          setSearchLoading(false)
          return false;
        });
    }
  }

  return (
    <div>
      <EditUser
        id={id}
        onFormSubmit={(data) => hendleSubmit(data)}
        navid={navid}
      />
      <div class="col-12 mypanel shadow">
        <Header_panel
          title="لیست شهرک ها"
          idMenu="#navbarToggleExternalContentUserList"
        />
        <div className="d-flex justify-content-center">
          {loading && (
            <>
              <Spinner animation="grow" variant="info" size="lg" />
              <div> صفحه در حال بارگزاری است ...</div>
            </>
          )}
        </div>
        <div class="pos-f-t">
          <div class="collapse" id="navbarToggleExternalContentUserList">
            <div class="p-4 mytable">
              <table class="table table-striped rtltable">
                <thead>
                  <tr>
                    <th>شماره</th>
                    <th>لوگو</th>
                    <th>نام</th>

                    <th>اطلاعات بیشتر</th>
                    <th>فعال</th>

                    {/* <th>فعالیت</th> */}
                    <th>واحد های صنعتی</th>
                    <th>جایگزین</th>
                    <th>ویرایش</th>
                    <th>حذف کاربر</th>
                  </tr>
                </thead>
                <tbody>
                  {rows
                    // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      return (
                        <tr>
                          <td>{page * rowsPerPage + index + 1}</td>
                          <td>
                            {row.image ? (
                              <img
                                src={`https://macks-b.ir/${row.image}`}
                                alt="عکس شهرک"
                                width="80"
                              />
                            ) : (
                              <img src={Addimage} alt="NoImage" width="80" />
                            )}
                          </td>

                          <td> {row.name}</td>

                          <td>
                            <ModalDetailUser1
                              buttonLabel="اطلاعات بیشتر"
                              title="اطلاعات بیشتر"
                              address={
                                row.address ? row.address : "آدرس ثبت نشده است"
                              }
                              description={
                                row.description
                                  ? row.description
                                  : "توضیحات ثبت نشده است"
                              }
                              townAdminFullName={
                                row.townAdminFullName
                                  ? row.townAdminFullName
                                  : "نام و نام خانوادگی ادمین ثبت نشده است"
                              }
                              townAdminMobile={
                                row.townAdminMobile
                                  ? row.townAdminMobile
                                  : "موبایل ادمین شهرک ثبت نشده است"
                              }
                            ></ModalDetailUser1>
                          </td>
                          <td>
                            {row.isActive ? (
                              <BsCheckCircle
                                style={{ color: "green" }}
                                onClick={() => {
                                  handleDeActive(row.id);
                                }}
                              />
                            ) : (
                              <BsXCircle
                                style={{ color: "red" }}
                                onClick={() => {
                                  handleActive(row.id);
                                }}
                              />
                            )}
                          </td>

                          {/* <td>
                            <Switch
                              color="primary"
                              checked={row.isActive}
                              onChange={handleChange("isActive")}
                              name="isActive"
                              value={row.id}
                              inputProps={{
                                "aria-label": "primary  checkbox",
                              }}
                            />
                          </td> */}
                          <td>
                            <Link to={`/main/indusUnit/${row.id}`}>
                              <IconButton>
                                <FcFactoryBreakdown />
                              </IconButton>
                            </Link>
                          </td>
                          <td>
                            <a onClick={() => { setShowChangeUnitone(true); setSelecredTown(row?.id) }}>
                              <p style={{ fontSize: "16px", fontWeight: "bold", color: "#b39ddb", cursor: "pointer" }}> مدیریت شهرک</p>
                            </a>
                          </td>
                          <td>
                            <Link to={`/main/user/${row.id}`}>
                              <IconButton
                                data-toggle="collapse"
                                data-target={!flag ? navid : ""}
                                color="primary"
                                onClick={() => {
                                  scrollBackToTop();
                                  setId(row.id);
                                  setflag(true);
                                }}
                              >
                                <FcInspection />
                              </IconButton>
                            </Link>
                          </td>
                          <td>
                            <IconButton onClick={() => hendleDelet(row.id)}>
                              <FcFullTrash />
                            </IconButton>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={ShowChangeUnitone}
        onClose={() => setShowChangeUnitone(false)}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className="changeUnitModal">
          <div className="container row">
            <div style={{ float: "left", textAlign: "left" }} className="col-lg-6">
              <IconButton onClick={() => setShowChangeUnitone(false)} className="CloseBtnModal" >
                <CloseRoundedIcon />
              </IconButton>
            </div>
            <div style={{ float: "right", textAlign: "right" }} className="col-lg-6">
              <h4 className="ModalTitle">جایگزین مدیریت واحد صنعتی</h4>
            </div>
            <div className="container row col-lg-12">
              <div className="col-lg-1">
                <IconButton onClick={() => handleSearchByPhone()} className="SearchBtnModal">
                  <SearchRoundedIcon />
                </IconButton>
              </div>
              <div className="col-lg-11">
                <input onChange={(e) => setSearchPhoen(e.target.value)} type="number" placeholder="... جستجو با شماره تماس" className="ModalSearch" />
              </div>
            </div>
            <div style={{ width: "100%" }}>
              <div className="MainReslut" style={{ marginTop: "30px" }}>
                {
                  SearchLoading ? (<CircularProgress color="secondary" />) : (null)
                }
                {
                  PhoneResult?.map(item => (
                    <p
                      onClick={() => { setSearchID(item?.id) }}
                      style={{ backgroundColor: item?.id === SearchID ? "rgb(40 216 161)" : "" }}
                      className="ResultFound">{item?.fullname}
                      <span
                        style={{
                          fontSize: "12px",
                          marginRight: "7px",
                        }}
                      >( {item?.mobile1} )</span></p>
                  ))
                }
              </div>
              {
                PhoneResult.length < 1 && Searching === true ? (
                  <div className="NotFoundMain" style={{ width: '100%' }}><p className="NotFoundMes">هیچ واحدی با این شماره پیدا نشد</p></div>
                ) : (<></>)
              }

              {
                Searching === true ? (
                  <Button className="SaveSearch" onClick={() => handleSaveSearchone()}>ذخیره</Button>
                ) : (null)
              }
            </div>
          </div>
        </div>
      </Modal >
      
      {/* <TablePagination
        rowsPerPageOptions={[10, 20, 50]}
        component="div"
        count={rowslength}
        rowsPerPage={rowsPerPage}
        page={page}
        labelRowsPerPage="تعداد نمایش :"
        nextIconButtonText="بعدی "
        backIconButtonText=" قبلی"
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      /> */}
    </div >
  );
}
